import { apiClient } from '@/api/api-client';
import { ApiResponse } from '@/types/api-response';

export interface ChangePasswordRequest {
  newPassword: string;
  confirmPassword: string;
}

export async function changePassword(
  request: ChangePasswordRequest
): Promise<ApiResponse<Object>> {
  const response = await apiClient.post<Object, ChangePasswordRequest>(
    '/me/change-password',
    request
  );
  return response;
}
